import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import * as t from 'prop-types';

import PortalContext from './PortalContext';
import ready from './ready';

class PortalProvider extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      portals: new Map(),
    };

    this.createPortal = children => {
      const element = document.createElement('div');
      ready(() => {
        document.body.appendChild(element);
        this.setState(({ portals: currentPortals }) => {
          const portals = new Map(currentPortals);
          portals.set(element, children);
          return { portals };
        });
      });
      return element;
    };

    this.updatePortal = (element, children) => {
      const { portals: currentPortals } = this.state;
      if (currentPortals.get(element) === children) return;
      this.setState(({ portals: previousPortals }) => {
        const portals = new Map(previousPortals);
        portals.set(element, children);
        return { portals };
      });
    };

    this.destroyPortal = element => {
      document.body.removeChild(element);
      this.setState(({ portals: currentPortals }) => {
        const portals = new Map(currentPortals);
        portals.delete(element);
        return { portals };
      });
    };
  }

  render() {
    const { children } = this.props;
    const { portals } = this.state;
    return (
      <PortalContext.Provider
        value={{
          createPortal: this.createPortal,
          destroyPortal: this.destroyPortal,
          updatePortal: this.updatePortal,
        }}
      >
        {children}
        {Array.from(portals.entries()).map(([el, child]) =>
          ReactDOM.createPortal(React.Children.toArray(child), el)
        )}
      </PortalContext.Provider>
    );
  }
}

PortalProvider.propTypes = {
  children: t.node,
};

PortalProvider.defaultProps = {
  children: [],
};

export default PortalProvider;
